import { useEffect } from 'react'
import Navigation from './Navigation'

const PitchScorecards = () => {
  useEffect(() => {
    const foundersData = [
      // Session 1 founders
      {
        name: "Giulia Eve Flores",
        company: "Lila Studios",
        scores: {
          "Problem Clarity": 8.1,
          "Solution Effectiveness": 7.8,
          "Team Credibility": 8.9,
          "Mission Alignment": 7.9,
          "Founder Authenticity": 9.8,
          "Investability": 7.1
        },
        overall: 8.8,
        investors: 7,
        interest: { meet: 3, refer: 1, pass: 3 }
      },
      {
        name: "Colleen Schell",
        company: "FABx: Storytelling and Speaking for Impact",
        scores: {
          "Problem Clarity": 8.3,
          "Solution Effectiveness": 6.8,
          "Team Credibility": 8.8,
          "Mission Alignment": 7.3,
          "Founder Authenticity": 9.3,
          "Investability": 6.0
        },
        overall: 8.1,
        investors: 6,
        interest: { meet: 2, refer: 1, pass: 3 }
      },
      {
        name: "Jacques Bazinet",
        company: "Talos Holdings LLC",
        scores: {
          "Problem Clarity": 8.5,
          "Solution Effectiveness": 9.5,
          "Team Credibility": 7.0,
          "Mission Alignment": 9.0,
          "Founder Authenticity": 10.0,
          "Investability": 7.5
        },
        overall: 8.0,
        investors: 2,
        interest: { meet: 2, refer: 0, pass: 0 }
      },
      {
        name: "Jesse Kunes",
        company: "Kinterest Group LLC",
        scores: {
          "Problem Clarity": 7.4,
          "Solution Effectiveness": 8.2,
          "Team Credibility": 8.2,
          "Mission Alignment": 7.6,
          "Founder Authenticity": 9.2,
          "Investability": 7.8
        },
        overall: 7.7,
        investors: 5,
        interest: { meet: 1, refer: 2, pass: 2 }
      },
      {
        name: "Vassilis Kertsikoff",
        company: "Vassilis Kertsikoff",
        scores: {
          "Problem Clarity": 8.3,
          "Solution Effectiveness": 8.8,
          "Team Credibility": 8.8,
          "Mission Alignment": 7.3,
          "Founder Authenticity": 8.5,
          "Investability": 8.8
        },
        overall: 8.3,
        investors: 4,
        interest: { meet: 1, refer: 1, pass: 2 }
      },
      {
        name: "Jackson Strong",
        company: "Aurea",
        scores: {
          "Problem Clarity": 6.8,
          "Solution Effectiveness": 6.8,
          "Team Credibility": 7.3,
          "Mission Alignment": 7.8,
          "Founder Authenticity": 8.0,
          "Investability": 6.2
        },
        overall: 7.3,
        investors: 6,
        interest: { meet: 0, refer: 3, pass: 3 }
      },
      {
        name: "Farhad Irani",
        company: "TheActualNews.org",
        scores: {
          "Problem Clarity": 8.0,
          "Solution Effectiveness": 6.9,
          "Team Credibility": 6.9,
          "Mission Alignment": 6.9,
          "Founder Authenticity": 7.8,
          "Investability": 6.1
        },
        overall: 7.0,
        investors: 7,
        interest: { meet: 1, refer: 0, pass: 6 }
      },
      {
        name: "Solay Rad",
        company: "Pray It Forward and The Church of Joy",
        scores: {
          "Problem Clarity": 6.5,
          "Solution Effectiveness": 4.5,
          "Team Credibility": 7.5,
          "Mission Alignment": 7.5,
          "Founder Authenticity": 10.0,
          "Investability": 3.0
        },
        overall: 6.5,
        investors: 2,
        interest: { meet: 0, refer: 0, pass: 2 }
      },
      {
        name: "Paul D'Souza",
        company: "The D'Souza Group",
        scores: {
          "Problem Clarity": 5.4,
          "Solution Effectiveness": 5.9,
          "Team Credibility": 6.5,
          "Mission Alignment": 6.8,
          "Founder Authenticity": 7.5,
          "Investability": 5.5
        },
        overall: 6.2,
        investors: 8,
        interest: { meet: 0, refer: 0, pass: 8 }
      },
      {
        name: "Jordan Burningham",
        company: "Diamond Detox",
        scores: {
          "Problem Clarity": 6.0,
          "Solution Effectiveness": 5.9,
          "Team Credibility": 6.8,
          "Mission Alignment": 6.2,
          "Founder Authenticity": 7.8,
          "Investability": 5.2
        },
        overall: 6.2,
        investors: 10,
        interest: { meet: 2, refer: 2, pass: 6 }
      },
      {
        name: "Juston Brommel",
        company: "Evolution & Geoship",
        scores: {
          "Problem Clarity": 6.8,
          "Solution Effectiveness": 5.8,
          "Team Credibility": 6.5,
          "Mission Alignment": 7.2,
          "Founder Authenticity": 7.8,
          "Investability": 5.3
        },
        overall: 6.0,
        investors: 5,
        interest: { meet: 1, refer: 0, pass: 4 }
      },
      // Session 2 founders
      {
        name: "Justin Brodie-Kommit",
        company: "Lichen Ventures",
        scores: {
          "Problem Clarity": 10.0,
          "Solution Effectiveness": 10.0,
          "Team Credibility": 10.0,
          "Mission Alignment": 10.0,
          "Founder Authenticity": 10.0,
          "Investability": 10.0
        },
        overall: 10.0,
        investors: 1,
        interest: { meet: 1, refer: 0, pass: 0 }
      },
      {
        name: "Doris Taylor",
        company: "Organamet Bio",
        scores: {
          "Problem Clarity": 10.0,
          "Solution Effectiveness": 10.0,
          "Team Credibility": 10.0,
          "Mission Alignment": 10.0,
          "Founder Authenticity": 10.0,
          "Investability": 9.0
        },
        overall: 9.8,
        investors: 2,
        interest: { meet: 2, refer: 0, pass: 0 }
      },
      {
        name: "Micha Mikailian",
        company: "Geoship",
        scores: {
          "Problem Clarity": 9.0,
          "Solution Effectiveness": 9.0,
          "Team Credibility": 10.0,
          "Mission Alignment": 10.0,
          "Founder Authenticity": 10.0,
          "Investability": 10.0
        },
        overall: 9.7,
        investors: 1,
        interest: { meet: 1, refer: 0, pass: 0 }
      },
      {
        name: "Kimba Williams",
        company: "KUSHAE",
        scores: {
          "Problem Clarity": 9.3,
          "Solution Effectiveness": 9.0,
          "Team Credibility": 9.3,
          "Mission Alignment": 9.0,
          "Founder Authenticity": 10.0,
          "Investability": 9.0
        },
        overall: 9.3,
        investors: 3,
        interest: { meet: 2, refer: 1, pass: 0 }
      },
      {
        name: "Steve Downey",
        company: "Thrive365, LLC",
        scores: {
          "Problem Clarity": 8.0,
          "Solution Effectiveness": 10.0,
          "Team Credibility": 10.0,
          "Mission Alignment": 9.0,
          "Founder Authenticity": 9.0,
          "Investability": 9.0
        },
        overall: 9.2,
        investors: 1,
        interest: { meet: 0, refer: 1, pass: 0 }
      },
      {
        name: "Katie Brown",
        company: "Scorpion Creek Ranch",
        scores: {
          "Problem Clarity": 9.5,
          "Solution Effectiveness": 8.5,
          "Team Credibility": 8.5,
          "Mission Alignment": 9.5,
          "Founder Authenticity": 10.0,
          "Investability": 8.0
        },
        overall: 9.0,
        investors: 2,
        interest: { meet: 1, refer: 0, pass: 1 }
      },
      {
        name: "James J. Piacentino",
        company: "Thrive Genetics",
        scores: {
          "Problem Clarity": 8.0,
          "Solution Effectiveness": 8.0,
          "Team Credibility": 9.0,
          "Mission Alignment": 9.0,
          "Founder Authenticity": 10.0,
          "Investability": 9.0
        },
        overall: 8.8,
        investors: 1,
        interest: { meet: 0, refer: 1, pass: 0 }
      },
      {
        name: "Raamayan",
        company: "Raamayan",
        scores: {
          "Problem Clarity": 8.0,
          "Solution Effectiveness": 8.0,
          "Team Credibility": 8.0,
          "Mission Alignment": 10.0,
          "Founder Authenticity": 10.0,
          "Investability": 8.0
        },
        overall: 8.7,
        investors: 1,
        interest: { meet: 1, refer: 0, pass: 0 }
      },
      {
        name: "Emily Kahn",
        company: "Myco Legacy, Inc.",
        scores: {
          "Problem Clarity": 8.0,
          "Solution Effectiveness": 9.0,
          "Team Credibility": 9.0,
          "Mission Alignment": 8.0,
          "Founder Authenticity": 10.0,
          "Investability": 8.0
        },
        overall: 8.7,
        investors: 1,
        interest: { meet: 1, refer: 0, pass: 0 }
      },
      {
        name: "Tirza Jova",
        company: "Milk by Mom",
        scores: {
          "Problem Clarity": 9.0,
          "Solution Effectiveness": 9.0,
          "Team Credibility": 8.3,
          "Mission Alignment": 9.0,
          "Founder Authenticity": 9.3,
          "Investability": 7.7
        },
        overall: 8.7,
        investors: 3,
        interest: { meet: 1, refer: 2, pass: 0 }
      },
      {
        name: "Joel Fariss",
        company: "Sysoma Partners",
        scores: {
          "Problem Clarity": 9.0,
          "Solution Effectiveness": 9.0,
          "Team Credibility": 8.0,
          "Mission Alignment": 8.0,
          "Founder Authenticity": 10.0,
          "Investability": 7.0
        },
        overall: 8.5,
        investors: 1,
        interest: { meet: 0, refer: 1, pass: 0 }
      },
      {
        name: "Steven Schwartz",
        company: "Bioharmonic Technologies",
        scores: {
          "Problem Clarity": 8.0,
          "Solution Effectiveness": 8.0,
          "Team Credibility": 10.0,
          "Mission Alignment": 8.0,
          "Founder Authenticity": 10.0,
          "Investability": 7.0
        },
        overall: 8.5,
        investors: 1,
        interest: { meet: 0, refer: 1, pass: 0 }
      },
      {
        name: "Roger Caldwell",
        company: "Firm Clean Power",
        scores: {
          "Problem Clarity": 10.0,
          "Solution Effectiveness": 10.0,
          "Team Credibility": 5.0,
          "Mission Alignment": 10.0,
          "Founder Authenticity": 9.0,
          "Investability": 7.0
        },
        overall: 8.5,
        investors: 1,
        interest: { meet: 1, refer: 0, pass: 0 }
      },
      {
        name: "Brandon Hives",
        company: "Evolutionary Mining",
        scores: {
          "Problem Clarity": 10.0,
          "Solution Effectiveness": 8.0,
          "Team Credibility": 6.0,
          "Mission Alignment": 9.0,
          "Founder Authenticity": 10.0,
          "Investability": 7.0
        },
        overall: 8.3,
        investors: 1,
        interest: { meet: 1, refer: 0, pass: 0 }
      },
      {
        name: "Nathan Kievman",
        company: "DeepTrust AI",
        scores: {
          "Problem Clarity": 8.0,
          "Solution Effectiveness": 8.0,
          "Team Credibility": 9.0,
          "Mission Alignment": 8.0,
          "Founder Authenticity": 8.0,
          "Investability": 9.0
        },
        overall: 8.3,
        investors: 1,
        interest: { meet: 1, refer: 0, pass: 0 }
      },
      {
        name: "Patrick Boze",
        company: "BonTerra Wellness",
        scores: {
          "Problem Clarity": 8.0,
          "Solution Effectiveness": 7.0,
          "Team Credibility": 8.0,
          "Mission Alignment": 8.0,
          "Founder Authenticity": 10.0,
          "Investability": 8.0
        },
        overall: 8.2,
        investors: 1,
        interest: { meet: 0, refer: 1, pass: 0 }
      },
      {
        name: "Bradley Morris",
        company: "Majik Kids, Play Chi Ball, Majik Media",
        scores: {
          "Problem Clarity": 7.5,
          "Solution Effectiveness": 8.0,
          "Team Credibility": 8.0,
          "Mission Alignment": 8.0,
          "Founder Authenticity": 9.5,
          "Investability": 7.5
        },
        overall: 8.1,
        investors: 2,
        interest: { meet: 1, refer: 1, pass: 0 }
      },
      {
        name: "Virginia Irwin Klausmeier",
        company: "Sylvatex Inc",
        scores: {
          "Problem Clarity": 5.5,
          "Solution Effectiveness": 9.0,
          "Team Credibility": 9.5,
          "Mission Alignment": 7.0,
          "Founder Authenticity": 7.5,
          "Investability": 6.5
        },
        overall: 7.5,
        investors: 2,
        interest: { meet: 1, refer: 0, pass: 1 }
      },
      {
        name: "Louis B. Laves-Webb",
        company: "Delta Pellets",
        scores: {
          "Problem Clarity": 6.0,
          "Solution Effectiveness": 7.0,
          "Team Credibility": 7.0,
          "Mission Alignment": 7.0,
          "Founder Authenticity": 7.0,
          "Investability": 7.0
        },
        overall: 6.8,
        investors: 1,
        interest: { meet: 0, refer: 0, pass: 1 }
      },
      {
        name: "Skylar Peterson",
        company: "Skycare",
        scores: {
          "Problem Clarity": 7.0,
          "Solution Effectiveness": 6.0,
          "Team Credibility": 8.0,
          "Mission Alignment": 6.0,
          "Founder Authenticity": 8.0,
          "Investability": 6.0
        },
        overall: 6.8,
        investors: 1,
        interest: { meet: 0, refer: 0, pass: 1 }
      },
      {
        name: "Shmuly Rosenblatt",
        company: "Golden Pine Village",
        scores: {
          "Problem Clarity": 7.0,
          "Solution Effectiveness": 7.0,
          "Team Credibility": 6.0,
          "Mission Alignment": 7.0,
          "Founder Authenticity": 8.0,
          "Investability": 4.0
        },
        overall: 6.5,
        investors: 1,
        interest: { meet: 0, refer: 1, pass: 0 }
      },
      {
        name: "Michael Langdon",
        company: "Chroma Drum",
        scores: {
          "Problem Clarity": 7.0,
          "Solution Effectiveness": 6.0,
          "Team Credibility": 7.0,
          "Mission Alignment": 5.0,
          "Founder Authenticity": 8.0,
          "Investability": 5.0
        },
        overall: 6.3,
        investors: 1,
        interest: { meet: 0, refer: 0, pass: 1 }
      }
    ]

    // Calculate summary statistics
    function calculateStats() {
      const totalFounders = foundersData.length
      const totalEvaluations = foundersData.reduce((sum, founder) => sum + founder.investors, 0)
      const averageScore = foundersData.reduce((sum, founder) => sum + founder.overall, 0) / totalFounders
      const totalMeet = foundersData.reduce((sum, founder) => sum + founder.interest.meet, 0)
      const totalRefer = foundersData.reduce((sum, founder) => sum + founder.interest.refer, 0)
      const successRate = ((totalMeet + totalRefer) / totalEvaluations) * 100
      
      // Update summary cards
      const totalFoundersEl = document.getElementById('totalFounders')
      const totalEvaluationsEl = document.getElementById('totalEvaluations')
      const averageScoreEl = document.getElementById('averageScore')
      const successRateEl = document.getElementById('successRate')
      
      if (totalFoundersEl) totalFoundersEl.textContent = totalFounders
      if (totalEvaluationsEl) totalEvaluationsEl.textContent = totalEvaluations
      if (averageScoreEl) averageScoreEl.textContent = averageScore.toFixed(1)
      if (successRateEl) successRateEl.textContent = successRate.toFixed(1) + '%'
    }
    
    function getScoreClass(score) {
      if (score >= 8) return 'excellent'
      if (score >= 7) return 'good'
      if (score >= 5) return 'moderate'
      return 'poor'
    }
    
    function createFounderCard(founder) {
      const meetPct = Math.round((founder.interest.meet / founder.investors) * 100)
      const referPct = Math.round((founder.interest.refer / founder.investors) * 100)
      const passPct = Math.round((founder.interest.pass / founder.investors) * 100)
      
      let scoresHtml = ''
      for (const [category, score] of Object.entries(founder.scores)) {
        const percentage = (score / 10) * 100
        scoresHtml += `
          <div class="score-bar">
            <div class="score-label">${category}</div>
            <div class="score-progress">
              <div class="score-fill ${getScoreClass(score)}" style="width: ${percentage}%">
                ${score.toFixed(1)}
              </div>
            </div>
          </div>
        `
      }
      
      return `
        <div class="founder-card">
          <div class="founder-header">
            <div class="founder-name">${founder.name}</div>
            <div class="founder-company">${founder.company}</div>
            <span class="investors-count">${founder.investors} investor${founder.investors !== 1 ? 's' : ''}</span>
          </div>
          <div class="overall-score">
            <div class="overall-score-value">${founder.overall.toFixed(1)}</div>
            <div class="overall-score-label">Overall Score</div>
          </div>
          <div class="founder-body">
            ${scoresHtml}
          </div>
          <div class="interest-badges">
            <div class="badge meet">Meet: ${meetPct}%</div>
            <div class="badge refer">Refer: ${referPct}%</div>
            <div class="badge pass">Pass: ${passPct}%</div>
          </div>
        </div>
      `
    }
    
    function renderTopPerformers() {
      const sortedFounders = [...foundersData].sort((a, b) => b.overall - a.overall)
      
      // Top performers with 2+ investors (more statistically reliable)
      const topWithMultipleInvestors = sortedFounders
        .filter(f => f.investors >= 2)
        .slice(0, 5)
      
      const topList = document.getElementById('topPerformersList')
      if (topList && topWithMultipleInvestors.length > 0) {
        topList.innerHTML = topWithMultipleInvestors.map((founder, index) => `
          <div class="top-item">
            <div class="rank">#${index + 1}</div>
            <div class="top-info">
              <div class="top-name">${founder.name}</div>
              <div class="top-company">${founder.company}</div>
            </div>
            <div class="top-score">${founder.overall.toFixed(1)}/10 <span style="font-size: 0.8rem; color: #95a5a6;">(${founder.investors} investors)</span></div>
          </div>
        `).join('')
      } else if (topList) {
        topList.innerHTML = '<p style="color: #7f8c8d;">No founders with multiple investor evaluations.</p>'
      }
      
      // Notable single evaluations (high scores but only 1 investor)
      const singleEvaluations = sortedFounders
        .filter(f => f.investors === 1 && f.overall >= 8.0)
        .slice(0, 5)
      
      const singleList = document.getElementById('singleEvaluationsList')
      if (singleList && singleEvaluations.length > 0) {
        singleList.innerHTML = singleEvaluations.map((founder, index) => `
          <div class="top-item">
            <div class="rank">#${index + 1}</div>
            <div class="top-info">
              <div class="top-name">${founder.name}</div>
              <div class="top-company">${founder.company}</div>
            </div>
            <div class="top-score">${founder.overall.toFixed(1)}/10 <span style="font-size: 0.8rem; color: #95a5a6;">(1 investor)</span></div>
          </div>
        `).join('')
      } else if (singleList) {
        singleList.innerHTML = '<p style="color: #7f8c8d;">No notable single evaluations.</p>'
      }
    }
    
    // Function to get last name for sorting
    function getLastName(fullName) {
      const parts = fullName.trim().split(/\s+/)
      return parts[parts.length - 1]
    }
    
    // Sort founders by last name alphabetically
    foundersData.sort((a, b) => {
      const lastNameA = getLastName(a.name).toLowerCase()
      const lastNameB = getLastName(b.name).toLowerCase()
      return lastNameA.localeCompare(lastNameB)
    })
    
    // Calculate and display stats
    calculateStats()
    
    // Render top performers (these still use score-based sorting)
    renderTopPerformers()
    
    // Render founder cards (now sorted alphabetically)
    const grid = document.getElementById('foundersGrid')
    if (grid) {
      foundersData.forEach(founder => {
        grid.innerHTML += createFounderCard(founder)
      })
    }
  }, [])

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        .scorecard-body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          background: linear-gradient(135deg, #031a6b 0%, #1b49c9 100%);
          min-height: calc(100vh - 80px);
          padding: 20px;
        }
        
        .scorecard-container {
          max-width: 1400px;
          margin: 0 auto;
        }
        
        .scorecard-header {
          background: white;
          padding: 40px;
          border-radius: 20px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.3);
          margin-bottom: 30px;
          text-align: center;
        }
        
        .scorecard-header h1 {
          color: #2c3e50;
          font-size: 2.5rem;
          margin-bottom: 10px;
        }
        
        .scorecard-subtitle {
          color: #7f8c8d;
          font-size: 1.2rem;
        }
        
        .summary-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }
        
        .card {
          background: white;
          padding: 25px;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 40px rgba(0,0,0,0.2);
        }
        
        .card-title {
          color: #7f8c8d;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 10px;
        }
        
        .card-value {
          color: #2c3e50;
          font-size: 2.5rem;
          font-weight: bold;
        }
        
        .card-subtitle {
          color: #95a5a6;
          font-size: 0.95rem;
          margin-top: 5px;
        }
        
        .founders-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 25px;
          margin-bottom: 30px;
        }
        
        .founder-card {
          background: white;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }
        
        .founder-card:hover {
          transform: scale(1.02);
          box-shadow: 0 15px 40px rgba(0,0,0,0.2);
        }
        
        .founder-header {
          padding: 20px;
          background: linear-gradient(135deg, #031a6b, #1b49c9);
          color: white;
        }
        
        .founder-name {
          font-size: 1.3rem;
          font-weight: bold;
          margin-bottom: 5px;
        }
        
        .founder-company {
          font-size: 0.95rem;
          opacity: 0.9;
        }
        
        .founder-body {
          padding: 20px;
        }
        
        .score-bar {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
        }
        
        .score-label {
          flex: 0 0 150px;
          font-size: 0.85rem;
          color: #7f8c8d;
        }
        
        .score-progress {
          flex: 1;
          height: 25px;
          background: #ecf0f1;
          border-radius: 12px;
          overflow: hidden;
          margin-right: 10px;
          position: relative;
        }
        
        .score-fill {
          height: 100%;
          background: linear-gradient(90deg, #1b49c9, #17C3B2);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 10px;
          color: white;
          font-weight: bold;
          font-size: 0.85rem;
          transition: width 1s ease;
        }
        
        .score-fill.excellent {
          background: linear-gradient(90deg, #17C3B2, #1b49c9);
        }
        
        .score-fill.good {
          background: linear-gradient(90deg, #1b49c9, #17C3B2);
        }
        
        .score-fill.moderate {
          background: linear-gradient(90deg, #FFB100, #FA8334);
        }
        
        .score-fill.poor {
          background: linear-gradient(90deg, #FA8334, #FFB100);
        }
        
        .interest-badges {
          display: flex;
          justify-content: space-around;
          padding: 15px;
          background: #f8f9fa;
          border-top: 1px solid #e9ecef;
        }
        
        .badge {
          text-align: center;
          padding: 8px 15px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: bold;
        }
        
        .badge.meet {
          background: #17C3B2;
          color: white;
        }
        
        .badge.refer {
          background: #1b49c9;
          color: white;
        }
        
        .badge.pass {
          background: #FA8334;
          color: white;
        }
        
        .overall-score {
          text-align: center;
          padding: 15px;
          background: #f8f9fa;
          border-bottom: 2px solid #e9ecef;
        }
        
        .overall-score-value {
          font-size: 2.5rem;
          font-weight: bold;
          color: #2c3e50;
        }
        
        .overall-score-label {
          font-size: 0.9rem;
          color: #7f8c8d;
          margin-top: 5px;
        }
        
        .top-performers {
          background: white;
          padding: 30px;
          border-radius: 15px;
          margin-bottom: 30px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }
        
        .top-performers h2 {
          color: #2c3e50;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
        }
        
        .trophy {
          font-size: 2rem;
          margin-right: 10px;
        }
        
        .top-list {
          display: grid;
          gap: 15px;
        }
        
        .top-item {
          display: flex;
          align-items: center;
          padding: 15px;
          background: linear-gradient(135deg, #031a6b15, #1b49c915);
          border-radius: 10px;
          border-left: 4px solid #1b49c9;
        }
        
        .rank {
          font-size: 1.5rem;
          font-weight: bold;
          color: #1b49c9;
          margin-right: 20px;
          width: 30px;
        }
        
        .top-info {
          flex: 1;
        }
        
        .top-name {
          font-weight: bold;
          color: #2c3e50;
          margin-bottom: 3px;
        }
        
        .top-company {
          color: #7f8c8d;
          font-size: 0.9rem;
        }
        
        .top-score {
          font-size: 1.8rem;
          font-weight: bold;
          color: #17C3B2;
        }
        
        @media (max-width: 768px) {
          .founders-grid {
            grid-template-columns: 1fr;
          }
          
          .scorecard-header h1 {
            font-size: 1.8rem;
          }
        }
        
        .feedback-section {
          margin-top: 15px;
          padding: 15px;
          background: #f8f9fa;
          border-radius: 8px;
          border-left: 3px solid #1b49c9;
        }
        
        .feedback-title {
          font-size: 0.9rem;
          color: #1b49c9;
          font-weight: bold;
          margin-bottom: 8px;
        }
        
        .investors-count {
          display: inline-block;
          padding: 4px 10px;
          background: #1b49c9;
          color: white;
          border-radius: 15px;
          font-size: 0.8rem;
          margin-left: 10px;
        }
      `}</style>
      <div className="scorecard-body">
        <Navigation />
        <div className="scorecard-container">
          <header className="scorecard-header">
            <h1>Impact Accelerator Summit</h1>
            <p className="scorecard-subtitle">Pitch Scorecards - October 2025</p>
          </header>
          
          <div className="summary-cards">
            <div className="card">
              <div className="card-title">Total Founders</div>
              <div className="card-value" id="totalFounders">35</div>
              <div className="card-subtitle">Unique companies pitched</div>
            </div>
            <div className="card">
              <div className="card-title">Total Evaluations</div>
              <div className="card-value" id="totalEvaluations">93</div>
              <div className="card-subtitle">Investor scorecards completed</div>
            </div>
            <div className="card">
              <div className="card-title">Average Score</div>
              <div className="card-value" id="averageScore">7.7</div>
              <div className="card-subtitle">Overall performance (out of 10)</div>
            </div>
            <div className="card">
              <div className="card-title">Success Rate</div>
              <div className="card-value" id="successRate">58.1%</div>
              <div className="card-subtitle">Meet + Refer requests</div>
            </div>
          </div>
          
          <div className="top-performers">
            <h2><span className="trophy">🏆</span> Top Performers <span style={{fontSize: '1rem', fontWeight: 'normal', color: '#7f8c8d'}}>(2+ investors)</span></h2>
            <div className="top-list" id="topPerformersList">
              {/* Top performers will be inserted here by JavaScript */}
            </div>
          </div>
          
          <div className="top-performers" style={{marginTop: '20px'}}>
            <h2><span style={{fontSize: '1.5rem', marginRight: '10px'}}>⭐</span> Notable Single Evaluations</h2>
            <div className="top-list" id="singleEvaluationsList">
              {/* Single evaluation performers will be inserted here by JavaScript */}
            </div>
          </div>
          
          <div className="founders-grid" id="foundersGrid">
            {/* Founder cards will be inserted here by JavaScript */}
          </div>
        </div>
      </div>
    </>
  )
}

export default PitchScorecards

